import { NewsHighlight } from './highlights';

export const HighlightsTranslationsFr: Partial<NewsHighlight>[] = [
  {
    title: `Nouvelle page : Maintenances en cours`,
    description: `Suivez toutes les **maintenances actuellement actives** depuis une page dédiée unique.

Visualisez immédiatement quels périmètres sont en maintenance en ce moment, afin d'**interpréter vos données en contexte** et d'éviter les fausses alertes.`,
  },
  {
    title: `Visualiseur HAR repensé`,
    imageAlt: `Fenêtre Waterfall listant 277 requêtes réseau avec leur statut, leur taille et leur chronologie.`,
    description: `Le **visualiseur HAR** a été repensé et est désormais **mieux intégré au portail**.

Il est également **plus rapide**, ce qui facilite l'exploration des waterfalls réseau.`,
  },
  {
    title: `🤖 IA agentique : serveur MCP`,
    description: `La plateforme propose désormais un **serveur MCP**, ouvrant la voie à l'**IA agentique**.

Connectez votre assistant IA préféré et laissez-le **interroger vos données, explorer vos mesures et faire émerger des informations** directement depuis la plateforme — le tout en langage naturel.`,
  },
  {
    title: `Scoring : options de calcul pour les SLAs`,
    description: `Les tableaux de scoring peuvent désormais afficher un **pourcentage calculé sur la période complète**, et plus seulement sans les maintenances.
Obtenez un **SLA adapté à vos besoins** d'un seul coup d'œil — les maintenances peuvent être intégrées ou pas sur la période sélectionnée, les considérant comme étant OK.`,
  },
  {
    title: `Scripts délégués : groupes d'actions`,
    imageAlt: `Le bouton « Ajouter un groupe d'actions » de l'éditeur de script.`,
    description: `Les étapes d'un script sont désormais organisées en **groupes d'actions**, apportant plus de structure et de clarté aux scripts complexes.

De plus, ces groupes d'actions peuvent être **partagés entre plusieurs scripts** — créez-en un une seule fois, réutilisez-le partout. Toute modification est **immédiatement répercutée sur tous les scripts** qui l'utilisent.

Gérez vos groupes partagés depuis la nouvelle page **Groupes d'actions partagés** dans les paramètres.`,
  },
  {
    title: `Scripts délégués : historique des versions`,
    imageAlt: `Panneau Versions du script : la version V1, sa date d'enregistrement et son auteur, étiquetée « En production » et « Courante ».`,
    description: `Les Scripts délégués conservent désormais un **historique complet des versions** de chaque script.

À chaque sauvegarde, une nouvelle version est enregistrée. Vous pouvez **consulter les versions précédentes**, comparer les modifications et **restaurer n'importe quelle version antérieure** à tout moment — un filet de sécurité précieux lors de l'itération sur des scripts complexes.`,
  },
  {
    title: `💡 Amélioration de la présentation des formulaires`,
    imageAlt: `Formulaire repensé : les champs d'une section « Informations générales », chacun sous son propre libellé, les champs obligatoires marqués d'un astérisque.`,
    description: `Nous avons amélioré la **conception et l'ergonomie des champs de saisie des formulaires** afin d'offrir une **meilleure expérience aux utilisateurs**.

Les formulaires sont désormais plus **organisés et intuitifs**, garantissant une plus grande clarté et une interaction plus aisée.`,
  },
  {
    title: `Nouveau widget : Grille d'états`,
    imageAlt: `Widget Grille d'états : dix cartes de mesures colorées selon leur état, vert pour OK, rouge pour critique, gris pour inconnu.`,
    description: `Le widget **Grille d'états** fournit un **aperçu visuel en direct des états actuels des mesures** à l'aide d'une grille de cartes colorées.

Il est conçu pour évaluer rapidement et d'un seul coup d'œil l'état d'un périmètre, en mettant l'accent sur la clarté et la visibilité en temps réel.`,
  },
  {
    title: `Authentification TOTP disponible !`,
    description: `Renforcez la sécurité de votre compte grâce à l’**authentification TOTP**.

Activez-la dès maintenant dans vos paramètres pour ajouter une étape de validation à chaque connexion et protéger davantage votre accès.`,
  },
  {
    title: `Nouveau widget : Tableau de durées des états consécutifs`,
    imageAlt: `Tableau des durées d'états consécutifs : par mesure, les périodes d'avertissement avec leur début, leur fin et leur durée.`,
    description: `Le widget **Tableau de durées des états consécutifs** met en évidence les **mesures qui restent dans le même état** au-delà d'un seuil configuré.

Il aide les équipes à identifier rapidement la persistance anormale d'états, tels que les avertissements de longue durée ou les conditions critiques.`,
  },
  {
    title: `⏯️ Découvrez les playlists de tableaux de bord !`,
    imageAlt: `Contrôles de playlist de la barre d'outils du tableau de bord : précédent, pause, suivant, et la barre de progression du tableau de bord courant.`,
    description: `Grâce aux playlists de tableaux de bord, vos **tableaux de bord défilent automatiquement** dans l'ordre que vous définissez, avec un temps d'affichage configurable pour chacun d'entre eux.

Idéales pour les grand écrans, les salles de contrôle, ou les présentations, vos tableaux de bord s'affichent sans effort, fournissant un **flux d'informations continu et dynamique**.

Suivez vos indicateurs clés en temps réel, repérez rapidement les tendances et **gardez toujours un œil sur ce qui compte le plus**.

Les playlists transforment vos tableaux de bord en une expérience visuelle moderne, fluide et entièrement automatisée qui rend la **surveillance plus efficace et plus agréable**.`,
  },
  {
    title: `Mise à jour de la documentation sur les tableaux de bord`,
    description: `Nous avons mis à jour notre **documentation sur les tableaux de bord 📖** afin de vous aider à vous lancer plus rapidement et à tirer le meilleur parti de toutes les fonctionnalités disponibles.

Vous y trouverez désormais :

- Un **Guide de démarrage** pour créer votre premier tableau de bord
- Un **Catalogue des widgets** détaillé avec des cas d'utilisation pratiques
- Des conseils sur les **Variables, les Rapports, et les Playlists**

Consultez-la directement dans la documentation et améliorez votre utilisation des tableaux de bord !`,
  },
];
